module.exports = __webpack_public_path__ + "media/images/patterns/wrapper-bottom-e5f008765a39dc7af8e21b8b0cfa45b9.svg";